/**
 * Weather types, and the one table that turns a number into words.
 *
 * The forecast comes from Open-Meteo, which needs no API key, asks for no
 * attribution and does not rate-limit a single household — the right shape of
 * dependency for something that has to keep working for years without anyone
 * remembering to renew a key. Alerts come from the US National Weather
 * Service, which is the actual source every American weather app quotes.
 */
export const WEATHER_CODES = {
    0: { label: 'Clear', scene: 'clear' },
    1: { label: 'Mainly clear', scene: 'clear' },
    2: { label: 'Partly cloudy', scene: 'partly' },
    3: { label: 'Overcast', scene: 'cloudy' },
    45: { label: 'Fog', scene: 'fog' },
    48: { label: 'Freezing fog', scene: 'fog' },
    51: { label: 'Light drizzle', scene: 'drizzle' },
    53: { label: 'Drizzle', scene: 'drizzle' },
    55: { label: 'Heavy drizzle', scene: 'drizzle' },
    56: { label: 'Freezing drizzle', scene: 'sleet' },
    57: { label: 'Freezing drizzle', scene: 'sleet' },
    61: { label: 'Light rain', scene: 'rain' },
    63: { label: 'Rain', scene: 'rain' },
    65: { label: 'Heavy rain', scene: 'rain' },
    66: { label: 'Freezing rain', scene: 'sleet' },
    67: { label: 'Freezing rain', scene: 'sleet' },
    71: { label: 'Light snow', scene: 'snow' },
    73: { label: 'Snow', scene: 'snow' },
    75: { label: 'Heavy snow', scene: 'snow' },
    77: { label: 'Snow grains', scene: 'snow' },
    80: { label: 'Light showers', scene: 'showers' },
    81: { label: 'Showers', scene: 'showers' },
    82: { label: 'Heavy showers', scene: 'showers' },
    85: { label: 'Snow showers', scene: 'snow' },
    86: { label: 'Heavy snow showers', scene: 'snow' },
    95: { label: 'Thunderstorm', scene: 'storm' },
    96: { label: 'Thunderstorm with hail', scene: 'storm' },
    99: { label: 'Severe thunderstorm', scene: 'storm' },
};
export function describeWeather(code) {
    return WEATHER_CODES[code] ?? { label: 'Unsettled', scene: 'cloudy' };
}
/** How many days the forecast view can show. Open-Meteo gives sixteen. */
export const FORECAST_LENGTHS = [3, 5, 7, 10, 14];
export const WEATHER_VIEWS = ['now', 'hourly', 'days'];
export const WEATHER_VIEW_LABELS = {
    now: 'Right now',
    hourly: 'Next 24 hours',
    days: 'The days ahead',
};
/** As many places as one widget will hold before it stops being readable. */
export const MAX_WEATHER_PLACES = 6;
/** A place in one line: "Elkhart, Indiana". */
export function placeLabel(place) {
    return place.admin1 ? `${place.name}, ${place.admin1}` : place.name;
}
//# sourceMappingURL=weather.js.map